module.exports = __webpack_public_path__ + "static/media/partnering.129452f6.svg";